import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";
import {
  SharedModuleDataWithSpace,
  SharedModuleType,
  SharedModuleDataWithAccount,
} from "views/Account/SharedModulesNew/types";

const SharedModulesTableTypeCell = ({
  item: sharedModule,
  ...cellProps
}: TableSimpleCellProps<SharedModuleDataWithSpace | SharedModuleDataWithAccount>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>
        {(() => {
          if (sharedModule.type === SharedModuleType.SPACE) {
            return "Space";
          }
          if (sharedModule.type === SharedModuleType.ACCOUNT) {
            return "Account";
          }
          return "";
        })()}
      </TableCellText>
    </TableSimpleCell>
  );
};

export default SharedModulesTableTypeCell;
